<div class="modal-body confirm-pass">
  <button (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <h2 class="heading">Enter Email</h2>  

  <mat-form-field class="example-full-width">
    <input type="email" matInput placeholder="Enter Email" [(ngModel)]="reenteremail" />
    <label *ngIf="submitted && reenteremail==null" style="color: red;">
      Email is required
    </label>
  </mat-form-field>
 
  <button type="button" class="primary-btn" (click)="changeEmailIdBeforeVerified()">
    SUBMIT
  </button>
</div>
